import { default as OwnerLanding } from './OwnerLanding'
export default OwnerLanding
export * as owner_landing from './model'
